/**
 * Módulo: Postventa (MVP — Mercado Libre)
 *
 * Centraliza la operación post-venta de los sellers en ML: reclamos,
 * devoluciones, reputación + tareas estructurales + tab Patrones (Casos).
 *
 * IMPORTANTE — Este módulo NO tiene UI propia ni route propia. El dashboard
 * vive en `src/modules/mercadolibre/dashboards/PostventaDashboard.jsx` y se
 * accede como card dentro de la grilla de dashboards de Mercado Libre
 * (`/empresas/{id}?tab=dash-todos&dashId=ml-postventa`).
 *
 * Este módulo existe como **catálogo de permisos**: define las 6 funciones
 * (`ver`, `ejecutar_agente`, `configurar_agente`, `crear_tarea`, `abrir_caso`,
 * `editar_nombre_agente`) que se aplican sobre acciones del dashboard.
 *
 * Plan completo: ver docs/postventa-mvp-plan.md.
 */
export default {
  id: 'postventa',
  nombre: 'Postventa',
  descripcion: 'Permisos del dashboard Postventa (vive como card de la grilla ML).',
  icono: 'rotate-ccw',
  tipo: 'operativo',
  version: '0.2.0',

  // No tiene rutas ni menuItems propios — el dashboard vive como card
  // dentro de Mercado Libre (registry de dashboards), no en el sidebar.
  routes: [],
  menuItems: [],

  features: [
    'postventa-dashboard',
    'postventa-tareas-estructurales',
    'postventa-tab-patrones',
    'postventa-agente-ia',
  ],

  // permisoModulos (#58): se deriva del rol.
  permisoModulos: ['postventa'],

}
